import React, {Component} from "react";
import styled from "styled-components";
import {NavLink} from "react-router-dom";
import {
  Contain,
  primary,
  grayText,
  ContainWPadding,
  IconModilect,
  HideOnMobile,
  mediaMaxPhone,
  dark
} from "../Tools/Variables";

export const HeaderHeight = "120px";

const Wrapper = styled.div `
  position: fixed;
  top: 0;
  width: 100%;
  background: none;
  z-index: 900;

  justify-content: space-around;
  flex-direction: column;
  display: flex;
  transition: 0.5s;
  padding: 20px 0;
  box-sizing:border-box;
  
`;

export const HeaderMargin = styled.div `
  height: ${HeaderHeight};

`;

const HeaderContent = styled.div `
  text-transform: uppercase;
  user-select: none;
  transition: 0.5s;
  margin: 0 auto;
  width: ${props => (props.ChangeHeader
  ? "100%"
  : "95%")};
  position: relative;
  flex: 1 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  box-sizing: border-box;
`;

const HeaderBg = styled.div `
  opacity: ${props => (!props.ChangeHeader
  ? "0.95"
  : "0")};
  transition: opacity 0.5s ease 0.5s;
  background: white;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
  `;

const HeaderBgOverlay = HeaderBg.extend `
opacity: ${props => (!props.ChangeHeader
  ? "0"
  : "1")};
background: ${dark};

`

const Tabs = styled.header `
  display: flex;
justify-content:center;
`;

const HeaderLine = styled.div `
  transition: opacity 1s ease;
  width: 100%;
  height: 2px;
  background: ${primary};
  margin: 0 auto;
`;

const Tab = styled.div `
  color: ${props => (props.ChangeHeader
  ? "white"
  : grayText)};
  text-decoration: none;
  cursor: pointer;
  margin: 0 10px;
  display: block;
  letter-spacing: 1.5px;
  font-weight: 500;
  font-size: 14px;
  transition: 0.9s ease;
  white-space: nowrap;

  &:hover {
    transform: translateY(3px);
  }
`;

const InterestedTab = Tab.extend `
  transition: 0.9s ease, background-color 0.2s ease-in-out 2s;
  background-color: ${props => (props.ChangeHeader
  ? "none"
  : primary)};
  padding: 0 10px;
`;

const FirstIcon = styled.div `
  opacity: ${props => (props.ChangeHeader
  ? "1"
  : "0")};
`;

const IconWrapper = styled.div `
  color: ${props => (props.ChangeHeader
  ? "white"
  : grayText)};
  top: 0;
  left: 0;
  margin: 0 auto;
  width: 45px;
  height:41px;
`;

class MenuContent extends Component {
  render() {
    return (
      <React.Fragment>
        <NavLink to="/">
          <Tab ChangeHeader={this.props.ChangeHeader}>Hem</Tab>
        </NavLink>

        <InterestedTab
          id={'IntrModalBtn_Header'}
          ChangeHeader={this.props.ChangeHeader}
          onClick={this.props.setShowContactModal}>
          Intresseanmälan
        </InterestedTab>
        <NavLink to="/about">
          <Tab
            style={{
            paddingRight: 10
          }}
            ChangeHeader={this.props.ChangeHeader}>Om</Tab>
        </NavLink>
      </React.Fragment>
    );
  }
}

class Header extends Component {
  state = {
    isTop: true
  };

  componentDidMount() {
    document.addEventListener("scroll", () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop) {
        this.setState({isTop});
      }
    });
  }

  render() {
    return (
      <Wrapper ChangeHeader={this.state.isTop}>
        <HeaderBg ChangeHeader={this.state.isTop}/> {this.props.headerBG
          ? <HeaderBgOverlay ChangeHeader={this.state.isTop}/>
          : ''}
        <Contain>
          <ContainWPadding>
            <HideOnMobile>
              <IconWrapper ChangeHeader={this.state.isTop}>
                <img src={IconModilect} alt="Modilect"/>
              </IconWrapper>
            </HideOnMobile>
            <HeaderContent ChangeHeader={this.state.isTop}>
              <HeaderLine ChangeHeader={this.state.isTop}/>

              <div
                style={{
                color: primary,
                margin: '5px 20px',
                fontWeight: '500',
                letterSpacing: '6.5px'
              }}>
                MODILECT
              </div>
              <HeaderLine ChangeHeader={this.state.isTop}/>
            </HeaderContent>
            <Tabs contactClose={this.state.contactMenu}>
              <MenuContent
                setShowContactModal={this.props.setShowContactModal}
                ChangeHeader={this.state.isTop}/>
            </Tabs>
          </ContainWPadding>
        </Contain>
      </Wrapper>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Global/Header.js